module.exports = {
    contract: {
        contract_remark: '合同备注',
        select_contract_template: '选择合同模板',
        contract_template_cannot_be_empty: '合同模板不能为空',
    }

}